import React, { useState } from "react";
import {
  InputCheck,
  NuFormInput,
  NuFormInputCheck,
  NuFormTextArea,
  NuInput,
  NuInputfile,
  NuTextArea,
} from "./Input";
import { CancelButton, SubmitButton } from "./Buttons";

function CommonDynamicForm({
  formData,
  formik,
  expandedIndex,
  index,
  allValue,
  setAllValue,
  SaveFormData,
  editModeIndex,
}) {
  function giveValue(value, formik) {
    switch (value?.field_type) {
      case "text":
        return (
          <>
            <div className={`w-full py-2 text-xs 2xl:text-sm `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label || "  "}</p>
                  </td>
                  <td className="w-2/5">
                    <NuFormInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      id={value?.id}
                      field_type={value?.field_type}
                      allValue={allValue}
                      setAllValue={setAllValue}
                      disabled={editModeIndex !== index}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "string":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs 2xl:text-sm mt-5 `}>
              <table className="w-full">
                <tr>
                  <td className="w-full">
                    <p>{value?.Name}</p>
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "yesno":
        return (
          <>
            <div className={`w-full py-2 text-xs 2xl:text-sm  mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  {[
                    { label: "Yes", type: "checkbox" },
                    { label: "No", type: "checkbox" },
                    { label: "N/A", type: "checkbox" },
                  ] &&
                    [
                      { label: "Yes", type: "checkbox" },
                      { label: "No", type: "checkbox" },
                      { label: "N/A", type: "checkbox" },
                    ].map((item, k) => {
                      return (
                        <td key={k}>
                          <div className="flex justify-center items-center gap-2">
                            <p>{item?.label || ""}</p>
                            <InputCheck
                              type={item?.type}
                              formik={formik}
                              placeholder={""}
                              name={item?.label}
                              id={value?.id}
                              field_type={value?.field_type}
                              allValue={allValue}
                              setAllValue={setAllValue}
                              disabled={editModeIndex !== index}
                            />
                          </div>
                        </td>
                      );
                    })}
                </tr>
              </table>
            </div>
          </>
        );
      case "checkbox":
        return (
          <>
            <div className={`w-full py-2 text-xs 2xl:text-sm  mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  {value?.metadata &&
                    Object.entries(value?.metadata).map(([key, valueOf]) => (
                      <td key={valueOf}>
                        <div className="flex justify-end items-center gap-2 w-[200px]">
                          <p>{key || ""}</p>
                          <NuFormInputCheck
                            fullValue={value?.value}
                            formik={formik}
                            placeholder={""}
                            name={key}
                            id={value?.id}
                            field_type={value?.field_type}
                            allValue={allValue}
                            setAllValue={setAllValue}
                            disabled={editModeIndex !== index}
                          />
                        </div>
                      </td>
                    ))}
                </tr>
              </table>
            </div>
          </>
        );
      case "textArea":
        return (
          <>
            <NuFormTextArea
              label=""
              placeholder={value?.field_label || ""}
              formik={formik}
              name={value?.field_label}
              new_width={"w-full"}
              id={value?.id}
              field_type={value?.field_type}
              allValue={allValue}
              setAllValue={setAllValue}
              disabled={editModeIndex !== index}
            />
          </>
        );
      case "observation":
        return (
          <>
            <NuFormTextArea
              label=""
              placeholder={value?.field_label || ""}
              formik={formik}
              name={value?.field_label}
              new_width={"w-full"}
              id={value?.id}
              field_type={value?.field_type}
              allValue={allValue}
              setAllValue={setAllValue}
              disabled={editModeIndex !== index}
            />
          </>
        );
      case "date":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs 2xl:text-sm `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={"date"}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      disabled={editModeIndex !== index}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "time":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs 2xl:text-sm `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.Name}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                      disabled={editModeIndex !== index}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "imagePath":
        return (
          <>
            <NuInputfile
              label={""}
              name={value?.field_label}
              handleChange={() => {}}
              width={"w-full"}
              placeholder="file upload"
            />
          </>
        );
        case "file":
          return (
            <>
              <NuInputfile
                label={""}
                name={value?.field_label}
                handleChange={() => {}}
                width={"w-full"}
                placeholder="file upload"
              />
            </>
          );
      case "table-data":
        return (
          <>
            <div className=" w-full">
              <table className=" w-full border text-xs">
                <thead>
                  <tr>
                    {value?.value &&
                      value?.value.map((item, k) => {
                        return (
                          <th key={k} className="text-left py-2 px-4 border">
                            {item?.label || ""}
                          </th>
                        );
                      })}
                  </tr>
                </thead>
                <tbody>
                  {Array(10)
                    .fill(0)
                    .map((_, i) => (
                      <tr key={i}>
                        {value?.value &&
                          value?.value.map((item, k) => {
                            return (
                              <td
                                key={k}
                                className="text-left py-2 px-4  h-8 border"
                              >
                                {""}
                              </td>
                            );
                          })}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        );
      case "multi":
        return (
          <>
            <div className=" w-full">
              {value?.metadata && Object.keys(value?.metadata).length > 3 ? (
                <div className="grid grid-cols-4 gap-2 items-center text-xs 2xl:text-sm ">
                  {Object.entries(value?.metadata).map(([key, valueOf],i) => (
                    <>
                      {valueOf == "text" ? (
                        <div
                          className={`${
                            Object.keys(value?.metadata).length >= 3
                              ? " w-full"
                              : " w-full"
                          } flex gap-3 items-center ${(i + 1) % 4 !== 1 ? "text-end" : "text-start"} `}
                        >
                          <p className=" w-1/2 ">{key || ""}</p>
                          <NuFormInput
                            label={key}
                            type={valueOf?.type}
                            formik={formik}
                            placeholder={valueOf?.Name}
                            name={valueOf?.value}
                            id={value?.id}
                            field_type={value?.field_type}
                            allValue={allValue}
                            setAllValue={setAllValue}
                            width={" w-1/2 "}
                            disabled={editModeIndex !== index}
                          />
                        </div>
                      ) : value == "string" ? (
                        <div className=" w-full">
                          <p className=" w-full">{key || ""}</p>
                        </div>
                      ) : (
                        <div className="w-full">
                          <p className="">{key || ""}</p>
                        </div>
                      )}
                    </>
                  ))}
                </div>
              ) : (
                <>
                  <table className="w-full ">
                    <tr>
                      {value?.metadata &&
                        Object.entries(value?.metadata).map(
                          ([key, valueOf]) => (
                            <>
                              <td key={key} className=" text-xs 2xl:text-sm text-end first:text-start">
                                {valueOf == "text" ? (
                                  <div
                                    className={`w-full flex gap-3 items-center `}
                                  >
                                    <p className=" w-1/2 ">{key || ""}</p>
                                    {/* <p className=" min-w-[500px]">{Object.keys(value?.metadata).length || "#"}</p> */}
                                    <NuFormInput
                                      label={key}
                                      type={valueOf?.type}
                                      formik={formik}
                                      placeholder={valueOf?.Name}
                                      name={valueOf?.value}
                                      id={value?.id}
                                      field_type={value?.field_type}
                                      allValue={allValue}
                                      setAllValue={setAllValue}
                                      width={" w-1/2 "}
                                      disabled={editModeIndex !== index}
                                    />
                                  </div>
                                ) : value == "string" ? (
                                  <>
                                    <p>{key || ""}</p>
                                  </>
                                ) : (
                                  <>
                                    <p>{key || ""}</p>
                                  </>
                                )}
                              </td>
                            </>
                          )
                        )}
                    </tr>
                  </table>
                </>
              )}
            </div>
          </>
        );
      case "tableRow":
        return (
          <>
            <table className="w-full">
              <tr>
                <td className="w-2/12">
                  <p>{value?.field_label}</p>
                </td>
                {
                  <>
                    {Object.entries(value?.metadata).map(([key, valueOf]) => (
                      <>
                        {valueOf == "text" ? (
                          <td
                            className={`${
                              Object.keys(value?.metadata).length >= 3
                                ? " w-full"
                                : " w-full"
                            } flex gap-3 items-center text-end first:text-start bg-red-400`}
                          >
                            <p className=" w-1/2">{key || ""}</p>
                            <NuFormInput
                              label={key}
                              type={valueOf?.type}
                              formik={formik}
                              placeholder={valueOf?.Name}
                              name={valueOf?.value}
                              id={value?.id}
                              field_type={value?.field_type}
                              allValue={allValue}
                              setAllValue={setAllValue}
                              width={" w-1/2 "}
                              disabled={editModeIndex !== index}
                            />
                          </td>
                        ) : value == "string" ? (
                          <td className=" w-full">
                            <p className=" w-full">{key || ""}</p>
                          </td>
                        ) : (
                          <td className="w-full">
                            <p className="">{key || ""}</p>
                          </td>
                        )}
                      </>
                    ))}
                  </>
                }
              </tr>
            </table>
          </>
        );
      default:
        return <>No</>;
    }
  }

  return (
    <>
      <div className="w-full mx-auto h-auto  rounded-md md:overflow-hidden   md:flex gap-2 text-[#111537]">
        <div className="w-full bg-white p-2 rounded-lg overflow-y-scroll">
          <React.Fragment key={index}>
            <div className={` ${expandedIndex === index ? " " : ""}`}>
              {expandedIndex === index && (
                <div className="py-4 px-2">
                  {formData &&
                    formData.map((tiltle, tiltleIndex) => {
                      return (
                        <div key={tiltleIndex} className="mb-4">
                          <label className="block text-sm 2xl:text-base font-medium text-gray-700 bg-slate-50 py-3 px-2">
                            {tiltle?.titleName || "-"}
                          </label>
                          {tiltle?.fields &&
                            tiltle?.fields.map((value, k) => {
                              return (
                                <div key={k} className="w-full">
                                  {giveValue(value, formik)}
                                </div>
                              );
                            })}
                        </div>
                      );
                    })}
                  {formData && (
                    <div className=" w-full flex justify-end items-center  gap-2 py-2 px-2 mb-10">
                      <CancelButton
                        name="Save"
                        handleClick={() => SaveFormData()}
                      />
                      <SubmitButton />
                    </div>
                  )}
                </div>
              )}
            </div>
          </React.Fragment>
        </div>
      </div>
    </>
  );
}

export default CommonDynamicForm;
